import { createTheme } from '@mui/material/styles';

export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
};

const lightPalette = {
  mode: THEME_MODES.LIGHT,
  primary: {
    main: '#9EDD53',
    light: '#FFFFFF',
    contrastText: '#141414',
  },
  error: {
    main: '#FF6669',
  },
  warning: {
    main: '#C1A700',
  },
  success: {
    main: '#9EDD53',
    contrastText: '#141414',
  },
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#141414',
    secondary: '#6E6E6E',
    disabled: '#979797',
  },
  divider: '#ACACAC',
  action: {
    disabledBackground: '#D5D5D5',
  },
};

const darkPalette = {
  mode: THEME_MODES.DARK,
  primary: {
    main: '#b9ff66',
    light: '#9eff33',
  },
  error: {
    main: '#FF6669',
  },
  warning: {
    main: '#EDDC69',
  },
  success: {
    main: '#b9ff66',
    contrastText: '#141414',
  },
  background: {
    default: '#141414',
    paper: '#2c2c2c',
  },
};

const scrollbarStyles = (mode) => {
  const isDark = mode === THEME_MODES.DARK;
  const trackColor = isDark ? '#232323' : '#F8FAFC';
  const thumbColor = isDark ? '#141414' : '#232323';

  return {
    '*::-webkit-scrollbar': {
      width: 8,
      height: 8,
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: trackColor,
      borderRadius: 4,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor,
      borderRadius: 4,
      backgroundClip: 'padding-box',
    },
    '*::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbColor,
    },
    '*::-webkit-scrollbar-corner': {
      backgroundColor: trackColor,
    },
    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumbColor} ${trackColor}`,
    },
  };
};

export const createAppTheme = (mode = THEME_MODES.DARK) =>
  createTheme({
    typography: {
      fontFamily: '"Montserrat", -apple-system, BlinkMacSystemFont, sans-serif',
    },
    palette: mode === THEME_MODES.LIGHT ? lightPalette : darkPalette,
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            lineHeight: 'normal',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: scrollbarStyles(mode),
      },
      MuiAlert: {
        styleOverrides: {
          filledError: {
            backgroundColor: mode === THEME_MODES.LIGHT ? '#D84B50' : '#FF6669',
            color: mode === THEME_MODES.LIGHT ? '#FFFFFF' : '#141414',
          },
          filledSuccess: {
            backgroundColor: mode === THEME_MODES.LIGHT ? '#5A8F24' : '#b9ff66',
            color: mode === THEME_MODES.LIGHT ? '#FFFFFF' : '#141414',
          },
        },
      },
    },
  });
